import React from 'react'
import ReactDOM from 'react-dom'

// ROUTING
import { BrowserRouter } from 'react-router-dom'
import Routes from 'Routes/'

// REDUX
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import combinedReducer from 'Reducers/combinedReducer'

//import * as serviceWorker from './serviceWorker'
import 'Common/common.css'

const store = createStore(
  combinedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

ReactDOM.render(
  <BrowserRouter basename="/">
    <Provider store={store}>
      <Routes />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.js